module.exports = "https://staticsandbox.coteibem.com.br/assets/logo-flat.d4e0bfdb923a4969d15bb08a75952f49.svg";